import { AnalogDut, AnalogInput, AnalogOutput, AnalogTemperatureSensor, BoilerAdapter, BoilerCascade, BoilerGroup, Buzzer, Command, Comparator, ConditionalOperator, DayTimetable, DigitalDut, GuardZone, HeatingCircuit, HeatingMode, IntervalTimetable, IOExtension, isNotOptimized, LogicExpression, ModBusDevice, ModBusSignal, Notification, OutputAction, Pause, Pump, Pza, RadioSensor, RadioSensor433, RelayControl, Scenario, SensorReading, StopScenario, ThreewayTap, TimeComparator, TimeInterval, TMKey, User, UserRole, WebElement, WeekTimetable, WiredTemperatureSensor, } from 'z3k-config';
import { getDeviceSpec, getDeviceSpecV2, } from '../../model/device-spec/z3k-feature-flags';
import { inputValue2PinId, inputValues2PinIds, outputValue2PinId, outputValues2PinIds, pinAlreadyUse, pinIdInArray, } from './pins';
import { all, all_merge, any, check_null_values, validate_array, validate_by_specification, } from '../collections';
import { conditional, EqualsThreshold, maxStringLength, minMax, minMaxStr, notEmpty, notEmptyAnd, notNull, notNullAnd, orNull, } from '../basic';
import { findLinksInObject, getAllInputs, getAllOutputs, getManagedMechanismOutputs, getRadioRelays, getRadioThermometers, getWiredTemperatureSensor, getZ3kEntityById, idExtractor, object2id, objects2ids, parsePhysicalIO, seemsLikeObjectId, z3kOwaMultiplier, } from 'z3k-parser/lib';
import { createSelector } from 'reselect';
import { k2c, partial, plural, removeNulls } from 'utils';
import { get_temperature_sensors_plus_adapters_ids, getDeviceInputsOptions, getDeviceOutputsOptions, isReserve, physical_and_modbus_analog_output_options, } from 'z3k-parser/lib/z3k-selectors';
import branding from 'shared/app/model/branding';
import { MQTTTopic } from 'z3k-parser/model/z3k-config/57-mqtt';
import { isClimatic } from 'shared/contexts/device/config/utils';
import { getControlTempRange } from 'shared/components/dialogs/heating-circuit-widget/utils';
import { getLatestFirmware } from 'entities/device.service.accessories.upgrade/lib/accessories-firmware';
export const shouldChosen = (num) => {
    return num === -1 ? 'Номер должен быть выбран' : null;
};
export const default_reactions = idExtractor([
    Notification,
    OutputAction,
    Scenario,
    Command,
]);
export const outputDontClashesWithInputs = (obj_type, physical_output, config) => {
    const { block_id } = parsePhysicalIO(physical_output);
    if (block_id != null &&
        objects2ids(IOExtension.get.where(config, IOExtension.isCE2)).includes(block_id)) {
        return null;
    }
    const spec = getDeviceSpec(config?.device?.name, config?.device?.hardware);
    const inputs = getAllInputs(config, false);
    const busy_pins = inputValues2PinIds(spec, inputs, IOExtension.get.all(config), getRadioRelays(config), true);
    const output_pin = outputValue2PinId(spec, { num: physical_output, obj_type, name: '' }, //name is not used in this scenario
    IOExtension.get.all(config), getRadioRelays(config));
    if (output_pin && pinIdInArray(output_pin, busy_pins))
        return 'Выход уже используется как Вход';
    return null;
};
export const outputDontClashesWithOutputActions = (physical_output, config) => {
    if (physical_output == -1) {
        return null;
    }
    return OutputAction.get.some(config, (oa) => oa.physical_output == physical_output)
        ? 'Выход используется в Действиях с выходами'
        : null;
};
const outputNumberIsValid = (physical_output_num, config) => {
    const oi_options = getDeviceOutputsOptions(config.login, getDeviceSpec(config?.device?.name, config?.device?.hardware), IOExtension.get.all(config), getRadioRelays(config), config.modbus_devices, config.modbus_signals, config.analog_outputs)
        .map((item) => item.value)
        .includes(physical_output_num);
    if (oi_options) {
        return null;
    }
    else {
        return 'Укажите номер выхода.';
    }
};
export const inputNumberIsValid = (physical_input_num, config) => {
    const oi_options = getDeviceInputsOptions(config.login, getDeviceSpec(config?.device?.name, config?.device?.hardware), IOExtension.get.all(config), getRadioRelays(config), true, true, config.modbus_devices, config.modbus_signals)
        .map((item) => item.value)
        .includes(physical_input_num);
    if (oi_options) {
        return null;
    }
    else {
        return 'Укажите номер входа.';
    }
};
export const inputNumberIsBusy = (obj_type, physical_input_num, config) => {
    const spec = getDeviceSpec(config?.device?.name, config?.device?.hardware);
    const io_extensions = IOExtension.get.all(config);
    const radio_relays = getRadioRelays(config);
    const busy_pins = inputValues2PinIds(spec, getAllInputs(config, false), io_extensions, radio_relays, true);
    const current_pin = inputValue2PinId(spec, { num: physical_input_num, obj_type, name: '' }, io_extensions, radio_relays, true);
    if (current_pin && pinAlreadyUse(current_pin, busy_pins)) {
        return 'Вход уже используется';
    }
    return null;
};
const get_temperature_sensors = createSelector(getWiredTemperatureSensor, AnalogTemperatureSensor.get.all, getRadioThermometers, (wts, ats, rs) => {
    return objects2ids([...wts, ...ats, ...rs]);
});
export const atLeastOneLink = (sensors) => {
    return sensors.length === 0
        ? 'Должна быть привязка хотя бы к одному датчику'
        : null;
};
export function noBrokenLinks(links, possible_ids) {
    if (links.some((link) => possible_ids.indexOf(link) == -1)) {
        return 'Выбран неизвестный объект';
    }
    return null;
}
export function validate_link(allow_null, get_valid_ids) {
    return (link, config) => {
        if (link == null) {
            if (allow_null)
                return null;
            return 'Нужно выбрать объект';
        }
        if (!get_valid_ids(config).includes(link)) {
            return 'Выбран неизвестный объект';
        }
        return null;
    };
}
export function validate_link_list(get_valid_ids) {
    return (link_list, config) => {
        const valid_ids = get_valid_ids(config);
        if (link_list.some((link) => valid_ids.indexOf(link) == -1)) {
            return 'Выбран неизвестный объект';
        }
        return null;
    };
}
export const validate_boiler_adapters = validate_by_specification({
    name: notEmpty,
    serial: all((serial) => notEmpty(serial.value), (serial, config) => BoilerAdapter.get.where(config, (ba) => ba.serial.value === serial.value).length > 1
        ? 'Серийный номер не уникален!'
        : null),
    max_modulation_level: notNullAnd(minMax(0, 100)),
    logged_parameter_register: (value, config) => {
        //outside
        if ((value & BoilerAdapter.Flags.IS_OUTSIDE) > 0 &&
            streetSensorCount(config) > 1) {
            return 'Уличный датчик уже выбран';
        }
        if ((value & BoilerAdapter.Flags.IS_OUTSIDE_RESERVE) > 0 &&
            reserveStreetSensorCount(config) > 1) {
            return 'Резервный уличный датчик уже выбран';
        }
        return null;
    },
    rol_connection_lost: validate_link_list(default_reactions),
    rol_connection_found: orNull(validate_link_list(default_reactions)),
    rol_boiler_failure: validate_link_list(default_reactions),
});
export const validate_buzzers = validate_by_specification({
    name: notEmpty,
    work_time: notNullAnd(minMax(0, 10)),
    physical_output: all(partial(outputDontClashesWithInputs, 'buzzers'), outputNumberIsValid),
});
export const validate_guard_indicators = all_merge(validate_by_specification({
    name: notEmpty,
    physical_output: all(partial(outputDontClashesWithInputs, 'guard_indicators'), outputNumberIsValid),
}));
export const validate_pumps = all(all_merge(validate_by_specification({
    name: notEmpty,
    physical_output: all(partial(outputDontClashesWithInputs, 'pumps'), outputNumberIsValid),
}), (pump, config) => {
    const is_climatic = isClimatic(config.device.name);
    return check_null_values({
        delay: is_climatic
            ? notNullAnd(minMax(0, 120))(pump.delay)
            : notNullAnd(minMax(0, 180))(pump.delay),
    });
}), conditional((pump) => pump.pressure_sensor != null, validate_by_specification({
    pressure_threshold: notNullAnd(minMax(0, 50, 'Допустимые значения: от 0 до 5')),
})));
export const validate_relay_controls = validate_by_specification({
    name: notEmpty,
    physical_output: all(partial(outputDontClashesWithInputs, 'relay_controls'), outputDontClashesWithOutputActions, outputNumberIsValid),
});
export const validate_threeway_taps = all_merge(validate_by_specification({
    name: notEmpty,
    step_time: notNullAnd(minMax(0, 10)),
    closing_time: notNullAnd(minMax(1, 300)),
    physical_output2: all(partial(outputDontClashesWithInputs, 'threeway_taps'), outputNumberIsValid),
}), (tap, config) => {
    const isAnalogOutput = AnalogOutput.get.some(config, (ao) => parsePhysicalIO(tap.physical_output2).block_id == ao.id);
    return check_null_values({
        step_period: (tap.setting_register & 0x1) === 0
            ? notNullAnd(minMax(10, 180))(tap.step_period)
            : null,
        coefficient: notNullAnd(minMax(0, isAnalogOutput ? 10 : 3))(tap.coefficient),
        physical_output1: isAnalogOutput
            ? null
            : all(partial(outputDontClashesWithInputs, 'threeway_taps'), outputNumberIsValid)(tap.physical_output1, config),
    });
});
export const validate_output_actions = all_merge(validate_by_specification({
    name: notEmpty,
    turn_on_delay: notNullAnd(minMax(0, 300)),
}), (output, config) => {
    const analog_output = AnalogOutput.get.one(config, (ao) => parsePhysicalIO(output.physical_output).block_id == ao.id);
    if (analog_output == null) {
        return null;
    }
    const valid = minMax(analog_output.min_value / analog_output.mult, analog_output.max_value / analog_output.mult);
    return check_null_values({
        analog_value: output.analog_value != null
            ? valid(output.analog_value / analog_output.mult)
            : null,
    });
}, (output, config) => {
    const physical_outputs = getManagedMechanismOutputs(config).map(({ num }) => num);
    let physical_output_validation = outputDontClashesWithInputs('output_actions', output.physical_output, config);
    if (!physical_output_validation &&
        physical_outputs.includes(output.physical_output)) {
        physical_output_validation =
            'Выход уже используется в Исполнительных устройствах';
    }
    if (physical_output_validation === null) {
        physical_output_validation = outputNumberIsValid(output.physical_output, config);
    }
    const pulses_len_validation = output.blink_pulses_len === 0
        ? null
        : notNullAnd(minMax(0, 10000))(output.blink_pulses_len) ||
            notNullAnd(minMax(-100000, output.blink_pulses_period - 1, 'Длительность импульса нельзя задать равным или большим, чем период импульса'))(output.blink_pulses_len);
    const pulses_period_validation = output.blink_pulses_period === 0
        ? null
        : notNullAnd(minMax(0, 10000))(output.blink_pulses_period) ||
            notNullAnd(minMax(output.blink_pulses_len + 1, 100000, 'Период импульса нельзя задать равным или меньшим, чем длительность импульса'))(output.blink_pulses_period);
    return check_null_values({
        action: output.action.type !== OutputAction.Type.ON_FOR_DURATION
            ? null
            : notNullAnd(minMax(0.1, 3600))(output.action.duration),
        physical_output: physical_output_validation,
        blink_pulses_len: pulses_len_validation,
        blink_pulses_period: pulses_period_validation,
    });
});
const getManagedAnalogOutputs = (config) => {
    const outputs = AnalogOutput.get.all(config).map((item) => item.physical_output);
    return outputs.filter((out) => out !== -1);
};
const MAX = 1_000_000;
const MIN = -1_000_000;
export const validate_analog_outputs = all_merge(validate_by_specification({
    name: notEmpty,
    unit: notNull,
    mult: notNull,
}), (ao, config) => {
    const min_v = ao.min_value;
    const max_v = ao.max_value;
    // const outputs = getManagedAnalogOutputs(config);
    // const count = outputs.filter((item) => item == ao.physical_output).length;
    // const all_available_outputs = physical_and_modbus_analog_output_options(
    //     config
    // ).flatMap(({options}) => options);
    const modbus_signal_ids = objects2ids(ModBusSignal.get.all(config));
    const is_modbus_output = ao.physical_output != null &&
        AnalogOutput.isModbusOutput({ physical_output: ao.physical_output }, modbus_signal_ids);
    return check_null_values({
        min_value: notNullAnd(minMax(MIN, max_v ?? MAX, `Допустимые значения: от ${MIN / (ao.mult ?? 1)} до ${(max_v ?? MAX) / (ao.mult ?? 1)}`))(ao.min_value),
        max_value: notNullAnd(minMax(min_v ?? MIN, MAX, `Допустимые значения: от ${(min_v ?? MIN) / (ao.mult ?? 1)} до ${MAX / (ao.mult ?? 1)}`))(ao.max_value),
        step: notNullAnd(minMax(!is_modbus_output ? 0.1 : 1, !is_modbus_output ? 100 : 10_000, `Допустимые значения: от ${1 / (ao.mult ?? 1)} до ${!is_modbus_output ? 10 : 10_000 / (ao.mult ?? 1)}`))(ao.step),
    });
});
export const inputDontClashesWithOutputs = (obj_type, physical_input, config) => {
    const { block_id } = parsePhysicalIO(physical_input);
    if (block_id != null &&
        objects2ids(IOExtension.get.where(config, IOExtension.isCE2)).includes(block_id)) {
        return null;
    }
    const spec = getDeviceSpec(config?.device?.name, config?.device?.hardware);
    const outputs = getAllOutputs(config);
    const busy_pins = outputValues2PinIds(spec, outputs, IOExtension.get.all(config), getRadioRelays(config));
    const input_pin = inputValue2PinId(spec, { num: physical_input, obj_type, name: '' }, IOExtension.get.all(config), getRadioRelays(config), true);
    if (input_pin && pinIdInArray(input_pin, busy_pins))
        return 'Вход уже используется как Выход';
    return null;
};
export function streetSensorCount(config) {
    return [
        WiredTemperatureSensor,
        AnalogTemperatureSensor,
        RadioSensor,
        BoilerAdapter,
    ].reduce(
    // @ts-ignore
    (sum, objNS) => sum + objNS.get.where(config, objNS.isOutside).length, 0);
}
export function reserveStreetSensorCount(config) {
    return [
        WiredTemperatureSensor,
        AnalogTemperatureSensor,
        RadioSensor,
        BoilerAdapter,
    ].reduce(
    // @ts-ignore
    (sum, objNS) => sum + objNS.get.where(config, objNS.isOutsideReserve).length, 0);
}
export function hasOutputTemperatureSource(config, has_stationary_location) {
    return streetSensorCount(config) > 0 || has_stationary_location;
}
export const onlyDigits = (value) => {
    // bug with temp sensors io_extnestion.serial
    if (value == '-1') {
        return null;
    }
    let i = value.length;
    while (i--) {
        const ch = value.charAt(i);
        if (ch < '0' || ch > '9') {
            return 'Допускаются только цифры';
        }
    }
    return null;
};
export const validate_io_extensions = validate_by_specification({
    serial: all(minMaxStr(0, 10), onlyDigits),
    name: notEmpty,
    rol_connection_lost: validate_link_list(default_reactions),
});
export const validate_ntc_temperature_curve = (ntc_object) => {
    const result = [];
    ntc_object.x.forEach((x) => {
        result.push(notNullAnd(minMax(0, 1e6))(x));
    });
    if (result.some((item) => item != null)) {
        return { x: result };
    }
    return null;
};
export function validateTemperatureOrMode(temp, { config, heating_circuit_id, }) {
    if (temp == null) {
        return 'Либо режим, либо температура должны быть выбраны';
    }
    if (HeatingMode.special_modes.includes(temp)) {
        return null;
    }
    if (!seemsLikeObjectId(temp)) {
        return null;
    } //minMax(2730, 3730)(temp); // Can't use minMax because it shows decikelvins in message.
    return noBrokenLinks([temp], HeatingMode.get
        .where(config, (mode) => mode.heating_zones.some(({ heating_circuit }) => heating_circuit === heating_circuit_id))
        .map(object2id));
}
function isPointInLine(x1, x2, x0) {
    // const result = (x1 < x0 && x0 < x2) || (x2 < x0 && x0 < x1);
    // if (result)
    //     console.log(
    //         'x1',
    //         x1,
    //         'x2',
    //         x2,
    //         'x0',
    //         x0,
    //         'x1 < x0',
    //         x1 < x0,
    //         'x0 < x2',
    //         x0 < x2,
    //         'x1 < x0 && x0 < x2',
    //         x1 < x0 && x0 < x2,
    //         'x2 < x0',
    //         x2 < x0,
    //         'x0 < x1',
    //         x0 < x1,
    //         'x2 < x0 && x0 < x1',
    //         x2 < x0 && x0 < x1,
    //         'result',
    //         (x1 < x0 && x0 < x2) || (x2 < x0 && x0 < x1)
    //     );
    return (x1 < x0 && x0 < x2) || (x2 < x0 && x0 < x1);
}
//TODO: железячники разберутся как работает в устройстве, тогда можно будет переделать валидацию
/**
 * @function validateTimeInterval - валидируем временные интервалы
 * @param id - ID интервала
 * @param add_info - дополнительная информация для валидации
 * 1. Если интервал действует только один день, значит он не имеет права переходить на следующий
 * 2. Если интервал действует 2 смежных дня, значит он может переходить через два дня (должны быть задействованы все 7)
 * 3. Если интервал действует через день, значит он аналогичен ситуации 1.
 * @return ValidationResult<TimeInterval>
 */
export function validateTimeInterval(id, add_info) {
    const { config, heating_circuit_id, time_intervals_id } = add_info;
    const is_climatic = isClimatic(config.device.name);
    if (is_climatic) {
        return null;
    }
    let time_interval;
    const time_intervals_other = removeNulls(TimeInterval.get.all(config).map((interval) => {
        if (interval.id === id) {
            time_interval = interval;
        }
        else if (time_intervals_id.includes(interval.id)) {
            return {
                index: time_intervals_id.indexOf(interval.id),
                interval,
            };
        }
        return;
    }));
    if (time_interval == null) {
        return 'Неизвестная ссылка [' + id + ']';
    }
    //sh = start_hour
    //sm = start_minutes
    //eh = end_hour
    //em = end_minutes
    const start_time = time_interval.sh * 60 + time_interval.sm, end_time = time_interval.eh * 60 + time_interval.em;
    const verdicts = removeNulls(time_intervals_other.map((ti) => {
        const interval = ti.interval;
        const start_time_interval = interval.sh * 60 + interval.sm, end_time_interval = interval.eh * 60 + interval.em;
        const verdict = (isPointInLine(start_time, end_time, start_time_interval) ||
            isPointInLine(start_time, end_time, end_time_interval) ||
            isPointInLine(start_time_interval, end_time_interval, start_time) ||
            isPointInLine(start_time_interval, end_time_interval, end_time)) &&
            (time_interval.action_register & interval.action_register) > 0;
        if (verdict)
            // console.log(
            //     'ti',
            //     ti,
            //     'start_time',
            //     start_time,
            //     'end_time',
            //     end_time,
            //     's_time_il',
            //     start_time_interval,
            //     'e_time_il',
            //     end_time_interval
            // );
            return ti.index + 1;
        return null;
    }));
    return verdicts.length > 0
        ? 'Есть пересечение с интервалами под номерами [ ' + verdicts.join(' , ') + ' ]'
        : check_null_values({
            temperature: validateTemperatureOrMode(time_interval.temperature, {
                config: config,
                heating_circuit_id,
            }),
        });
}
export const validate_modbus_signal = validate_by_specification({
    name: maxStringLength(50, 'Максимальная длина названия 50 символов'),
    var_length: minMax(1, 300),
    var_count: minMax(1, 16),
    var_period_repeat: minMax(0, 320),
    buffer_offset: minMax(0, 320),
    address: minMax(0, 65535, 'Допустимые значения:\n0-65535\n'),
    division_coefficient: orNull(minMax(1, 1000, 'Допустимые значения:\n1-1000\n')),
});
export const validate_mqtt_topic = (item) => {
    if (MQTTTopic.isPublicationTopic(item) &&
        item.type_object === 255 &&
        item.link_list.length === 0) {
        return {
            link_list: 'Нужно выбрать объекты',
            type_object: 'Нужно выбрать тип объектов',
        };
    }
    else {
        return null;
    }
};
export const validate_warnings_modbus_signal = validate_by_specification({
    type: shouldChosen,
});
export const validate_modbus_device = all(validate_by_specification({
    name: maxStringLength(50, 'Максимальная длина названия 50 символов'),
    address: minMax(1, 247),
    period: minMax(0.2e3, 300e3, 'Допустимый диапазон: 0.2—300 сек'),
    time_for_disconnect: minMax(60e3, 60 * 60e3, 'Допустимый диапазон: 1—60 мин'),
    signals: validate_link_list(idExtractor([ModBusSignal])),
}), (mbDevice, config) => {
    if (ModBusDevice.get
        .where(config, (mbDev) => mbDev.id != mbDevice.id)
        .some((mbDev) => mbDev.address == mbDevice.address))
        return `Адрес ${mbDevice.address} назначен двум разным устройствам ModBus`;
    return null;
});
//надо, чтобы совпадало с ScenarioLinkId
export const default_scenario_links = idExtractor([
    Notification,
    OutputAction,
    Scenario,
    Command,
    Pause,
    ConditionalOperator,
    Comparator,
    LogicExpression,
    SensorReading,
    TimeComparator,
    StopScenario,
]);
export const boolean_condition_link_ids = idExtractor([
    Comparator,
    TimeComparator,
    LogicExpression,
    SensorReading,
]);
/**
 * @function validateScenariosLinksCyclicallyUsed - находим циклические зависимости
 * @param scenario - текущий сценарий
 * @param config - Z3KConfig
 * @param used_ids - используемые ссылки
 * @return ValidationResult
 */
export function validateScenariosLinksCyclicallyUsed(scenario, config, used_ids) {
    const scenarios = config.scenarios?.filter((shit) => scenario.links.includes(shit.id)) ?? [];
    if (scenarios.length === 0) {
        return null;
    }
    //Выбираем в каких используем друг друга
    const scenariosHaveUsedIds = scenarios.filter((shit) => used_ids.includes(shit.id));
    if (scenariosHaveUsedIds.length !== 0) {
        return scenariosHaveUsedIds.flatMap((value) => {
            return `${value.name} циклично используется`;
        });
    }
    const end = scenarios
        .flatMap((scenario) => validateScenariosLinksCyclicallyUsed(scenario, config, scenarios.map((scenario) => scenario.id)))
        .filter((item) => item != null);
    return end.length ? end : null;
}
function translate(type) {
    switch (type) {
        case 'pauses':
            return 'пауза';
        case 'conditional_operators':
            return 'операторы условия';
        case 'comparators':
            return 'компаратор';
        case 'logic_expressions':
            return 'логические выражения';
        case 'sensor_readings':
            return 'значение датчика или состояние датчика';
        case 'time_comparators':
            return 'временной компаратор';
        case 'stop_scenarios':
            return 'прерывание сценария';
        default:
            return type;
    }
}
export function validateScenarioRecursiveLink(scenario, config) {
    return validateScenariosLinksCyclicallyUsed(scenario, config, [
        scenario.id,
    ]);
}
/**
 * @function validateBlocklyObjects - проверяем все объекты blockly
 * @param config - Z3KConfig and used_ids
 * @param type - тип Z3KConfig'a
 * @param z3k_item - объект, который будем проверять
 * @return ValidationResult + id
 */
function validateBlocklyObjects(config, type, z3k_item) {
    function send_result(func) {
        const result = func(z3k_item, config);
        if (result != null && typeof result === 'object') {
            console.error(`Ошибка в элементе типа: ${type}, ID: ${z3k_item.id} `, result);
            return { translate_type: translate(type), ...result };
        }
        return result;
    }
    //Валидировать будем только элементы сложного сценария
    switch (type) {
        case 'pauses':
            return null;
        case 'conditional_operators':
            return send_result(validate_conditional_operator);
        case 'comparators':
            return send_result(validate_comparator);
        case 'logic_expressions': {
            return send_result(validate_logic_expression);
        }
        case 'sensor_readings':
            return send_result(validate_sensor_reading);
        case 'time_comparators':
            return null;
        case 'scenarios':
            return validateScenarioRecursiveLink(z3k_item, config);
        case 'stop_scenarios':
            return null;
        default:
            return null;
    }
}
/**
 * @function validateComplexScenario - проверяем все объекты этого сценария
 * @param scenario - текущий сценарий
 * @param config - Z3KConfig and used_ids
 * @return ValidationResult
 */
export function validateComplexScenario(scenario, config) {
    const visit_links = [];
    function recursiveSearch(link_id) {
        //Узнаём тип элемента, используемого в конфиге
        const [type, z3k_item] = getZ3kEntityById(config, link_id);
        //Если с ним всё плохо, то ругаемся
        if (z3k_item == null || type == null || type === 'scenarios') {
            return [];
        }
        //Смотрим на все используемые в нём линки
        //Убираем ссылку на сценарий (избегаем цикла бесконечного)
        //Убираем ссылку на себя
        //И не будем ходить туда, где уже были
        const used_links = findLinksInObject(config, link_id).filter((id) => id !== link_id && !visit_links.includes(id));
        //Сложим новые ссылки в посещаемые
        visit_links.push(...used_links);
        return [
            //Добавляю результат валидации корневого элемента
            validateBlocklyObjects(config, type, z3k_item),
            //Добавляем результаты валидации детей
            ...used_links.flatMap(recursiveSearch),
        ];
    }
    //исследуем, кого использует этот сценарий
    const messages = scenario.links
        .flatMap(recursiveSearch)
        .filter((item) => item != null)
        .map((message) => {
        if (message != null && typeof message === 'object') {
            if ('translate_type' in message) {
                const { translate_type } = message;
                return `Пустой блок в типе ${translate_type}`;
            }
        }
        return message;
    });
    return messages.length > 0 ? messages.toString() : null;
}
export function validateScenario(current_scenario, config) {
    const recursive_links = validateScenariosLinksCyclicallyUsed(current_scenario, config, [current_scenario.id]);
    const validation_result_complex_scenario = validateComplexScenario(current_scenario, config);
    return check_null_values({
        name: notEmpty(current_scenario.name),
        links: recursive_links != null &&
            recursive_links[0] != null &&
            recursive_links[0].includes(current_scenario.name)
            ? recursive_links
            : validation_result_complex_scenario != null
                ? validation_result_complex_scenario
                : validate_link_list(default_scenario_links)(current_scenario.links, config),
    });
}
function validateWarningsScenarios() {
    return check_null_values({});
}
export const NoOneLink = (sensors) => {
    return sensors.length === 0 ? null : 'Должен быть NULL';
};
export const validate_conditional_operator = (conditional_operator, config) => {
    switch (conditional_operator.type) {
        case ConditionalOperator.Type.IF_THEN:
            return validate_by_specification({
                comparator_id: validate_link(false, boolean_condition_link_ids),
                statementThen: all(atLeastOneLink, validate_link_list(default_scenario_links)),
                statementElse: NoOneLink,
            })(conditional_operator, config);
        case ConditionalOperator.Type.IF_THEN_ELSE:
            return validate_by_specification({
                comparator_id: validate_link(false, boolean_condition_link_ids),
                statementThen: all(atLeastOneLink, validate_link_list(default_scenario_links)),
                statementElse: all(atLeastOneLink, validate_link_list(default_scenario_links)),
            })(conditional_operator, config);
    }
};
const sensor_reading_ids = idExtractor([SensorReading]);
export const validate_comparator = validate_by_specification({
    left_object_id: validate_link(false, sensor_reading_ids),
    right_object_id: validate_link(true, sensor_reading_ids),
});
export const minCountArray = (min_count) => (objects) => objects.length >= min_count ? null : 'Нужно больше объектов';
export const validate_logic_expression = (logic_expression, config) => {
    switch (logic_expression.type) {
        case LogicExpression.Type.AND:
        case LogicExpression.Type.OR:
            return validate_by_specification({
                conditions: all(atLeastOneLink, minCountArray(2), validate_link_list(boolean_condition_link_ids)),
            })(logic_expression, config);
        case LogicExpression.Type.NOT:
            return validate_by_specification({
                conditions: all(atLeastOneLink, validate_link_list(boolean_condition_link_ids)),
            })(logic_expression, config);
    }
};
const validate_sensor_reading_obj_id = validate_link(false, idExtractor([
    GuardZone,
    HeatingCircuit,
    RelayControl,
    Pump,
    ThreewayTap,
    Buzzer,
    BoilerAdapter,
    AnalogInput,
    WiredTemperatureSensor,
    RadioSensor,
    RadioSensor433,
    AnalogTemperatureSensor,
]));
const validate_sensor_reading = (sensor_reading, config) => {
    switch (sensor_reading.type) {
        case SensorReading.Type.VALUE:
            return check_null_values({
                argument: [0, null].includes(sensor_reading.argument)
                    ? null
                    : //Может быть не нуль для RadioSensor
                        validate_link(false, idExtractor([RadioSensor]))(sensor_reading.obj_id, config),
                obj_id: validate_sensor_reading_obj_id(sensor_reading.obj_id, config),
            });
        case SensorReading.Type.STATE:
            return check_null_values({
                obj_id: validate_sensor_reading_obj_id(sensor_reading.obj_id, config),
                argument: sensor_reading.argument > 100
                    ? validate_link(false, idExtractor([HeatingMode]))(sensor_reading.argument, config)
                    : null,
            });
    }
};
export const validate_boiler_cascades = all_merge(validate_by_specification({
    name: notEmpty,
    rotation_period: minMax(0, 30),
    hysteresis: minMax(0, 20),
    boiler_list: all((list) => list.length < 2
        ? 'Необходимо выбрать несколько контуров котла'
        : null, validate_link_list(createSelector(HeatingCircuit.get.all, (hcs) => hcs.filter(HeatingCircuit.isBoiler).map(object2id)))),
    water_sensor: validate_link(true, get_temperature_sensors),
    preferred_modulation: orNull(minMax(10, 100)),
}), (bc, config) => {
    const is_climatic = isClimatic(config.device.name);
    return check_null_values({
        lead_boiler_switch_delay: is_climatic
            ? minMax(0, 120)(bc.lead_boiler_switch_delay)
            : minMax(0, 300)(bc.lead_boiler_switch_delay),
        slave_boiler_start_delay: is_climatic
            ? minMax(0, 250)(bc.slave_boiler_start_delay)
            : minMax(0, 300)(bc.slave_boiler_start_delay),
        slave_boiler_finish_delay: is_climatic
            ? minMax(0, 250)(bc.slave_boiler_finish_delay)
            : minMax(0, 300)(bc.slave_boiler_finish_delay),
    });
});
const validate_analog_input_physical_input_num = (analog_input, config) => {
    if (analog_input.sensor_type === AnalogInput.Type.SMOKE) {
        return null;
    }
    const has_a300_inputs = getDeviceSpec(config?.device?.name, config?.device?.hardware).autoscan.has_a300_inputs;
    if (has_a300_inputs &&
        AnalogInput.a300FrequencySensorTypes.includes(analog_input.sensor_type) &&
        analog_input.physical_input_num >= 0) {
        if ((config.analog_inputs ?? []).filter((ai) => AnalogInput.a300FrequencySensorTypes.includes(ai.sensor_type) &&
            ai.physical_input_num === analog_input.physical_input_num).length > 1) {
            return 'Входы частотных сенсоров должны различаться';
        }
    }
    const valid_number = inputNumberIsValid(analog_input.physical_input_num, config);
    if (valid_number != null) {
        return valid_number;
    }
    return inputDontClashesWithOutputs('analog_inputs', analog_input.physical_input_num, config);
};
function getCalibrationMinMax(calibration_table) {
    let max = 0, min = 0;
    if (calibration_table) {
        calibration_table.table.forEach((row) => {
            if (row.value > max) {
                max = row.value;
            }
            if (row.value < min) {
                min = row.value;
            }
        });
    }
    return { min, max };
}
export const validate_analog_inputs = all_merge(validate_by_specification({
    name: notEmpty,
    active_level_timeout: minMax(0.01, 3600),
    inactive_level_timeout: minMax(0.01, 3600),
    notification_list: validate_link_list(default_reactions),
    recovery_list: validate_link_list(default_reactions),
    upper_notification_list: validate_link_list(default_reactions),
}), (analog_input, config) => {
    const calibration_table = AnalogInput.isUseCalibrationTable(analog_input)
        ? (config.calibration_tables ?? []).find((item) => item.id === analog_input.calibration) ?? null
        : null;
    const validateThreshold = (threshold) => {
        const multiplier = AnalogInput.getMultiplier(analog_input);
        if (calibration_table != null) {
            if (calibration_table.table.length >= 2) {
                const { min, max } = getCalibrationMinMax(calibration_table);
                return orNull(minMax(min / multiplier, max / multiplier))(threshold);
            }
            return 'В калибровочной таблице нужны хотя бы 2 элемента';
        }
        if (AnalogInput.isUseResistance(analog_input)) {
            return orNull(minMax(0, 0.5 * multiplier))(threshold);
        }
        return orNull(minMax(0, AnalogInput.getThresholdMax(analog_input)))(threshold);
    };
    return check_null_values({
        physical_input_num: validate_analog_input_physical_input_num(analog_input, config),
        upper_threshold: validateThreshold(analog_input.upper_threshold),
        lower_threshold: validateThreshold(analog_input.lower_threshold),
        impulse_frequency: getDeviceSpec(config?.device?.name, config?.device?.hardware).autoscan.has_a300_inputs
            ? minMax(1, 50000)(analog_input.impulse_frequency)
            : null,
        calibration: calibration_table
            ? calibration_table.table.length >= 2
                ? null
                : 'В калибровочной таблице нужны хотя бы 2 элемента'
            : null,
    });
});
export const validate_warnings_analog_inputs = (analog_input, config) => {
    const calibration_table = AnalogInput.isUseCalibrationTable(analog_input)
        ? (config.calibration_tables ?? []).find((item) => item.id === analog_input.calibration) ?? null
        : null;
    function isPrecise(num) {
        return /\d+\.\d{1}/gm.test(String(num));
    }
    const message = calibration_table?.table.some((el) => isPrecise(el.value) || isPrecise(el.voltage))
        ? 'Работа датчика не гарантируется при точности больше десятичной'
        : null;
    return check_null_values({
        physical_input_num: shouldChosen(analog_input.physical_input_num),
        calibration: message,
    });
};
export const validate_web_elements = all_merge((we, config) => {
    const active_output = OutputAction.get.one(config, (item) => item.id === we.id_active)?.physical_output;
    const passive_output = OutputAction.get.one(config, (item) => item.id === we.id_passive)?.physical_output;
    const active_cmd_objectid = Command.get.one(config, (item) => item.id === we.id_active)?.objectid;
    const passive_cmd_objectid = Command.get.one(config, (item) => item.id === we.id_passive)?.objectid;
    const outputs_differ_msg = !WebElement.isComplexType(we)
        ? null
        : active_output != null &&
            passive_output != null &&
            active_output !== passive_output
            ? 'Аппаратные выходы в действиях должны совпадать'
            : active_cmd_objectid != null &&
                passive_cmd_objectid != null &&
                active_cmd_objectid !== passive_cmd_objectid
                ? 'Привязанные к командам объекты должны совпадать'
                : null;
    return check_null_values({
        label1: WebElement.isAnalogType(we) ? null : notEmpty(we.label1),
        label2: WebElement.isSimpleType(we) || WebElement.isAnalogType(we)
            ? null
            : notEmpty(we.label2),
        id_active: WebElement.isAnalogType(we)
            ? we.id_active == null
                ? 'Должен быть выбран'
                : noBrokenLinks([we.id_active], AnalogOutput.get.all(config).map(object2id))
            : WebElement.isStatusType(we)
                ? !WebElement.isSetOutputState(we)
                    ? we.id_active == null
                        ? 'Должен быть выбран'
                        : noBrokenLinks([we.id_active], AnalogInput.get.all(config).map(object2id))
                    : null
                : we.id_active == null
                    ? 'Должен быть выбран'
                    : outputs_differ_msg == null
                        ? validate_link(false, default_reactions)(we.id_active, config)
                        : outputs_differ_msg,
        id_passive: WebElement.isAnalogType(we)
            ? null
            : [WebElement.Type.STATUS, WebElement.Type.SIMPLE].includes(we.type)
                ? we.id_passive == null
                    ? null
                    : 'Для данного типа параметр отсутствует'
                : we.id_passive == null
                    ? 'Должен быть выбран'
                    : outputs_differ_msg == null
                        ? validate_link(false, default_reactions)(we.id_passive, config)
                        : outputs_differ_msg,
    });
});
const validate_warnings_web_elements = (web_element) => check_null_values({
    id_active: WebElement.isStatusType(web_element) &&
        WebElement.isSetOutputState(web_element)
        ? shouldChosen(web_element.id_active)
        : null,
});
const validateTemp = (zone, config) => {
    if ([
        HeatingMode.OFF_MODE,
        HeatingMode.REQUEST_MODE,
        HeatingMode.RESERVE_MODE,
        HeatingMode.ALWAYS_ON_MODE,
    ].includes(zone.temperature_setting)) {
        return null;
    }
    const current_hc = HeatingCircuit.get.one(config, (hc) => hc.id === zone.heating_circuit);
    if (isClimatic(config?.device?.name)) {
        if (!current_hc)
            return null;
        if (current_hc.type === HeatingCircuit.Type.DHW) {
            return minMax(20, 75)(k2c(zone.temperature_setting));
        }
        else if (current_hc.type === HeatingCircuit.Type.HEATING &&
            HeatingCircuit.getControlModeClimatic(current_hc) ===
                HeatingCircuit.ControlMode.WATER) {
            return minMax(Number(current_hc.water_min_temperature) ?? 5, Number(current_hc.water_max_temperature) ?? 35)(k2c(zone.temperature_setting));
        }
        else if (current_hc.type === HeatingCircuit.Type.COOLING) {
            return minMax(0, 80)(k2c(zone.temperature_setting));
        }
        else {
            return minMax(5, 35)(k2c(zone.temperature_setting));
        }
    }
    //Если управляем по ТН, но есть ПЗА
    const pza_able = current_hc == null
        ? false
        : (HeatingCircuit.isBoiler(current_hc) ||
            HeatingCircuit.isConsumer(current_hc)) &&
            HeatingCircuit.hasPZA(current_hc);
    if (pza_able && current_hc && !HeatingCircuit.isPZARequestOnlyMode(current_hc)) {
        return minMax(0, 50, 'Используется ПЗА, допустимые значения: от 0° до 50°')(k2c(zone.temperature_setting));
    }
    const { min_temperature, max_temperature } = current_hc != null
        ? getControlTempRange(current_hc, undefined, config)
        : { min_temperature: -30, max_temperature: 130 };
    return minMax(min_temperature, max_temperature)(k2c(zone.temperature_setting));
};
const get_temperature_settings = idExtractor([
    DayTimetable,
    WeekTimetable,
    IntervalTimetable,
]);
export const validate_heating_modes = all_merge(validate_by_specification({
    name: notEmpty,
    heating_zones: all_merge(validate_array(all_merge(validate_by_specification({
        adjusting_sensor: validate_link(true, get_temperature_sensors),
    }), (zone, config) => {
        const firmware = +config.device.firmware;
        const current_hc = HeatingCircuit.get.one(config, (hc) => hc.id === zone.heating_circuit);
        const pza_able = current_hc == null
            ? false
            : (HeatingCircuit.isBoiler(current_hc) ||
                HeatingCircuit.isConsumer(current_hc)) &&
                (firmware < 63 || current_hc.pza);
        const temperature_setting_possible_values = get_temperature_settings(config);
        if (pza_able && firmware < 63)
            temperature_setting_possible_values.push(...objects2ids(Pza.get.all(config)));
        const interval_timetable = IntervalTimetable.get.one(config, (it) => it.id === zone.temperature_setting);
        return check_null_values({
            temperature_setting: !seemsLikeObjectId(zone.temperature_setting)
                ? validateTemp(zone, config)
                : interval_timetable != null
                    ? check_null_values({
                        time_intervals: validate_array(validateTimeInterval)(interval_timetable.time_intervals, 
                        //  @ts-ignore
                        {
                            config,
                            heating_circuit_id: zone.heating_circuit,
                            time_intervals_id: interval_timetable.time_intervals,
                        }),
                        outside_default: validateTemperatureOrMode(interval_timetable.outside_default, {
                            config: config,
                            heating_circuit_id: zone.heating_circuit,
                        }),
                    })
                    : noBrokenLinks([zone.temperature_setting], temperature_setting_possible_values),
            pza: zone.pza == null
                ? null
                : pza_able
                    ? noBrokenLinks([zone.pza], Pza.get.all(config).map(object2id))
                    : 'Для данной конфигурации ПЗА не должен быть выбран',
        });
    })), (hzs, config) => {
        const hcs = new Map();
        hzs.forEach(({ heating_circuit }) => {
            if (hcs.has(heating_circuit)) {
                hcs.set(heating_circuit, hcs.get(heating_circuit) + 1);
            }
            else {
                hcs.set(heating_circuit, 0);
            }
        });
        const res = hzs.map((hz) => {
            let heating_circuit_text;
            const hc_repeat_text = hcs.get(hz.heating_circuit) >= 1
                ? 'Отопительные контуры в режиме не должны повторяться'
                : null;
            if (hc_repeat_text) {
                heating_circuit_text = hc_repeat_text;
            }
            else if (hz.heating_circuit == null) {
                heating_circuit_text = 'Должно быть выбрано';
            }
            else {
                heating_circuit_text = noBrokenLinks([hz.heating_circuit], [
                    ...HeatingCircuit.get.all(config),
                    ...BoilerCascade.get.all(config),
                ].map(object2id));
            }
            if (heating_circuit_text) {
                return {
                    heating_circuit: heating_circuit_text,
                };
            }
            return null;
        });
        if (res.every((item) => item == null)) {
            return null;
        }
        return res;
    }),
    // setting_register
}), (hm, config) => {
    const is_boiler_mode = HeatingMode.hasBoilerMode(hm, HeatingCircuit.get.all(config), BoilerCascade.get.all(config));
    const is_boiler_reserve_mode = is_boiler_mode &&
        hm.heating_zones.some(({ temperature_setting }) => isReserve(temperature_setting, DayTimetable.get.all(config), WeekTimetable.get.all(config), IntervalTimetable.get.all(config), TimeInterval.get.all(config)));
    return check_null_values({
        start_reserve_delay: !is_boiler_reserve_mode
            ? null
            : minMax(10, 300)(hm.start_reserve_delay),
        water_sensor: !is_boiler_reserve_mode
            ? null
            : hm.water_sensor == null
                ? 'Должно быть выбрано'
                : noBrokenLinks([hm.water_sensor], get_temperature_sensors(config)),
        max_modulation_level: hm.max_modulation_level === 0 ||
            hm.max_modulation_level === undefined
            ? null
            : minMax(1, 100)(hm.max_modulation_level),
    });
});
function validate_heating_zone(hz, config) {
    const week = WeekTimetable.get.byId(config, hz.temperature_setting);
    if (week == null) {
        return null;
    }
    const data = removeNulls(week.temp7.map((id) => DayTimetable.get.byId(config, id)?.temp24));
    if (data.length < 7) {
        return {
            temperature_setting: 'Не хватает объектов в недельном расписании. Попробуйте создать его заново.',
        };
    }
    if (isNotOptimized(data))
        return { temperature_setting: 'Оптимизируйте недельное расписание' };
    return null;
}
export const validate_warnings_heating_modes = (heating_mode, config) => {
    const id_mode = HeatingMode.getModeTypePerZone(heating_mode, HeatingCircuit.get.all(config), BoilerCascade.get.all(config));
    const is_boiler_mode = Object.values(id_mode).includes(HeatingMode.MODE_TYPE.BOILER);
    const is_not_pure_boiler_mode = Object.values(id_mode).includes(HeatingMode.MODE_TYPE.MIXED);
    const heating_zone_messages = is_boiler_mode && is_not_pure_boiler_mode
        ? heating_mode.heating_zones.map((zone) => id_mode[zone.heating_circuit] === HeatingMode.MODE_TYPE.BOILER
            ? {
                heating_circuit: 'Рекомендуется вынести котлы и каскады в отдельный режим. Актуально только для версии прошивки 70 и выше',
            }
            : null)
        : [];
    const heating_zones_validation_result = validate_array(validate_heating_zone)(heating_mode.heating_zones, config);
    if (heating_zones_validation_result != null)
        return { heating_zones: heating_zones_validation_result };
    return heating_zone_messages.some((e) => e != null)
        ? check_null_values({ heating_zones: heating_zone_messages })
        : null;
};
const validate_physical_output = validate_by_specification({
    physical_output: shouldChosen,
});
const validate_warnings_analog_outputs = all_merge(validate_by_specification({
    name: notEmpty,
    unit: notNull,
    mult: notNull,
}), (ao, config) => {
    const outputs = getManagedAnalogOutputs(config);
    const count = outputs.filter((item) => item == ao.physical_output).length;
    const all_available_outputs = physical_and_modbus_analog_output_options(config).flatMap(({ options }) => options);
    return check_null_values({
        physical_output: count > 1
            ? 'Выход занят'
            : all_available_outputs
                .map((output) => output.id)
                .includes(ao.physical_output ?? -1) &&
                ao.physical_output !== -1
                ? null
                : 'Не выбрано устройство',
    });
});
const validate_warnings_analog_temperature_sensors = validate_by_specification({
    physical_input_num: shouldChosen,
});
const validate_warnings_io_extensions = all_merge(validate_by_specification({
    serial: notEmpty,
}), (_, config) => {
    const spec = getDeviceSpecV2(config?.device?.name, config?.device?.hardware);
    if (!spec) {
        return null;
    }
    if (!spec.io.io_extensions_supported ||
        spec.io.max_amount_io_extensions == null) {
        return null;
    }
    //Было сделано для снятия ограничений по количеству блоков для конкретного прибора!
    //неограничивать количество блоков для некоторых приборов(по серийнику в zk3config)
    if (IOExtension.getVipSerialExpansionUnit().includes(config.login.toLowerCase())) {
        return null;
    }
    // надо ограничивать количество IOExtensions
    const external_io_extensions_count = IOExtension.get.where(config, IOExtension.countMaxAmount).length;
    return external_io_extensions_count > spec.io.max_amount_io_extensions
        ? `Максимально допустимое количество блоков расширения ${spec.io.max_amount_io_extensions}`
        : null;
}, (item) => {
    const io_extension = item;
    if (!IOExtension.canUpdate(io_extension)) {
        return null;
    }
    const fw = IOExtension.getHardwareAndSoftwareVersion(io_extension).fw;
    const last_firmwares = window._ui.store.getState()?.last_accessories_firmwares.versions;
    if (!last_firmwares) {
        return null;
    }
    const latest_firmware = getLatestFirmware(IOExtension, io_extension, last_firmwares);
    const last_fw = latest_firmware?.latest.version;
    if (!last_fw) {
        return null;
    }
    if (last_fw === fw) {
        return null;
    }
    return 'Доступно обновление';
});
function validateThresholdWired(sensor, threshold) {
    const owa_m = z3kOwaMultiplier(sensor);
    //@ts-ignore
    if (threshold === '' || threshold == null) {
        return null;
    }
    return (orNull(minMax(-50 * owa_m, 400 * owa_m))(threshold * owa_m) ??
        EqualsThreshold(sensor.lower_threshold, sensor.upper_threshold));
}
function validateThresholdAnalog(sensor, threshold) {
    //@ts-ignore
    if (threshold === '' || threshold == null) {
        return null;
    }
    //@ts-ignore
    if (sensor.lower_threshold === '' || sensor.upper_threshold === '') {
        return null;
    }
    return (orNull(minMax(-50, 400))(threshold) ??
        EqualsThreshold(sensor.lower_threshold, sensor.upper_threshold));
}
function validateThresholdRadio(sensor, threshold) {
    //@ts-ignore
    if (threshold === '' || threshold == null) {
        return null;
    }
    //@ts-ignore
    if (sensor.lower_threshold === '' || sensor.upper_threshold === '') {
        return null;
    }
    return (orNull(minMax(-50, 120))(threshold) ??
        EqualsThreshold(sensor.lower_threshold, sensor.upper_threshold));
}
export const validate_wired_temperature_sensors = all_merge(validate_by_specification({
    serial: notEmpty,
    no_connection_timeout: notNullAnd(minMax(0, 10)),
    setting_register: (value, config) => {
        if ((value & WiredTemperatureSensor.Flags.IS_OUTSIDE) > 0 &&
            streetSensorCount(config) > 1) {
            return 'Уличный датчик уже выбран';
        }
        if ((value & WiredTemperatureSensor.Flags.IS_OUTSIDE_RESERVE) > 0 &&
            reserveStreetSensorCount(config) > 1) {
            return 'Резервный уличный датчик уже выбран';
        }
        return null;
    },
    rol_connection_lost: validate_link_list(default_reactions),
    rol_temperature_upper_threshold: validate_link_list(default_reactions),
    rol_temperature_lower_threshold: validate_link_list(default_reactions),
    recovery_list: validate_link_list(default_reactions),
    io_extension_id: any((x) => (x === 0 ? /*ok*/ null : 'not null'), validate_link(true, idExtractor([IOExtension, ModBusSignal]))),
    calibration_shift: orNull(minMax(-10, 10)),
}), (sensor, config) => {
    const owa_m = z3kOwaMultiplier(sensor);
    const is_climatic = isClimatic(config.device.name);
    return check_null_values({
        name: is_climatic
            ? notEmptyAnd(maxStringLength(20, 'должно быть не более 20 знаков'))(sensor.name)
            : notEmpty(sensor.name),
        upper_threshold: validateThresholdWired(sensor, sensor.upper_threshold),
        lower_threshold: validateThresholdWired(sensor, sensor.lower_threshold),
        hysteresis: notNullAnd(minMax(0, 100 * owa_m))(sensor.hysteresis * owa_m),
    });
});
const validate_warnings_wired_temperature_sensors = (sensor, config) => {
    if (sensor.serial === '0') {
        const io_extension = sensor.io_extension_id != null
            ? IOExtension.get.byId(config, sensor.io_extension_id)
            : undefined;
        const is_thermostat_ml_232 = io_extension != null && IOExtension.isML232Thermostat(io_extension);
        return is_thermostat_ml_232 && Number(config.device.firmware) < 328
            ? 'Требуется обновить устройство до версии не ниже 328'
            : null;
    }
    const duplicates = WiredTemperatureSensor.get.where(config, ({ serial }) => sensor.serial.length > 1 && sensor.serial === serial).length;
    return check_null_values({
        serial: duplicates > 1 ? 'Датчик с таким серийным номером уже существует' : null,
    });
};
const validate_warnings_notification = (notification) => {
    if (Notification.isSpeakerEnabled(notification)) {
        return null;
    }
    return check_null_values({
        recipient_list: notification.recipient_list == null ||
            notification.recipient_list.length === 0
            ? 'Получатель не назначен'
            : null,
    });
};
const validate_warnings_threeway_taps = (threeway_tap, config) => {
    return check_null_values({
        physical_output1: !ThreewayTap.isTwoWay(threeway_tap) &&
            !AnalogOutput.get.some(config, (ao) => parsePhysicalIO(threeway_tap.physical_output2).block_id == ao.id)
            ? shouldChosen(threeway_tap.physical_output1)
            : null,
        physical_output2: shouldChosen(threeway_tap.physical_output2),
        step_time: threeway_tap.step_time === threeway_tap.step_period
            ? 'Плавное регулирование сервоприводом невозможно, cмотри справку.'
            : null,
    });
};
const validate_warnings_users = (user) => {
    return check_null_values({
        phone: notEmpty(user.phone),
    });
};
const validate_warnings_heating_circuits = (hc, config) => {
    // --- Проверка control_device ---
    const used_cd = new Map();
    HeatingCircuit.get.all(config).forEach((_hc) => {
        _hc.control_devices.map((id) => {
            if (used_cd.has(id)) {
                used_cd.set(id, used_cd.get(id) + 1);
            }
            else {
                used_cd.set(id, 0);
            }
        });
    });
    Pump.get.all(config).forEach(({ id }) => {
        if (used_cd.has(id)) {
            used_cd.delete(id);
        }
    });
    BoilerAdapter.get.all(config).forEach(({ id }) => {
        if (used_cd.has(id)) {
            used_cd.delete(id);
        }
    });
    let warnUsedControlDevice = null;
    hc.control_devices.forEach((con_dev_id) => {
        if (used_cd.get(con_dev_id) >= 1) {
            warnUsedControlDevice =
                'Некоторые исполнительные устройства используются в нескольких тепловых контурах. Возможно, система будет работать некорректно';
        }
    });
    const device_spec = getDeviceSpec(config?.device?.name, config?.device?.hardware);
    if (device_spec.heating.has_heating &&
        device_spec.heating.has_extended_heating &&
        hc.control_devices.length === 0 &&
        HeatingCircuit.isBoiler(hc)) {
        warnUsedControlDevice = 'Не назначено исполнительное устройство';
    }
    // --- Проверка control_device end---
    const strangePZA = !isClimatic(config?.device?.name) &&
        HeatingCircuit.hasPZA(hc) &&
        !Pza.get.some(config, ({ id }) => id === hc.pza)
        ? 'Отсутствует объект ПЗА у (' + hc.name + '), хотя на него ссылается'
        : null;
    const has_weather_sensor = Boolean(streetSensorCount(config));
    const pza_weather_sensor_validation = (hc) => {
        if (!has_weather_sensor && hc.pza !== 0) {
            return 'Нужно назначить датчик улицы';
        }
        return null;
    };
    return check_null_values({
        air_temp_sensor: !((HeatingCircuit.isAirConsumerMode(hc) ||
            HeatingCircuit.isAirPIDConsumerMode(hc)) &&
            HeatingCircuit.isConsumer(hc))
            ? null
            : hc.air_temp_sensor == null
                ? 'Должен быть выбран'
                : null,
        dhw_temp_sensor: !HeatingCircuit.isDHW(hc) || HeatingCircuit.isFlowDHW(hc)
            ? null
            : hc.dhw_temp_sensor == null
                ? 'Должен быть выбран'
                : null,
        water_temp_sensor: hc.water_temp_sensor == null
            ? HeatingCircuit.isConsumer(hc) &&
                (HeatingCircuit.isWaterConsumerMode(hc) ||
                    HeatingCircuit.isAirPIDConsumerMode(hc))
                ? 'Должен быть выбран'
                : null
            : null,
        pza: strangePZA || pza_weather_sensor_validation(hc),
        heat_request: (HeatingCircuit.isDHW(hc) || HeatingCircuit.isConsumer(hc)) &&
            hc.heat_request === HeatingCircuit.TARGET_BOILER_TEMPERATURE_REQUEST
            ? 'Данный тип запроса не поддерживается'
            : null,
        control_devices: warnUsedControlDevice,
    });
};
const select_guard_zone_sensors = createSelector(AnalogInput.get.all, RadioSensor.get.all, RadioSensor433.get.all, (analog_inputs, radiosensors, radiosensors433) => [
    ...analog_inputs,
    ...radiosensors.filter((obj) => RadioSensor.isMotionSensor(obj) || RadioSensor.isLeakSensor(obj)),
    ...radiosensors433,
].map(object2id));
export const validate_guard_zone = validate_by_specification({
    name: notEmpty,
    event_delay_time: notNullAnd(minMax(0, 180)),
    start_delay: notNullAnd(minMax(0, 1000)),
    relative_sensor_list: all(atLeastOneLink, validate_link_list(select_guard_zone_sensors)),
    relative_triggered_list: validate_link_list(default_reactions),
    relative_recovered_list: validate_link_list(default_reactions),
    relative_turned_on: validate_link_list(default_reactions),
    relative_turned_off: validate_link_list(default_reactions),
});
export const validate_notification = validate_by_specification({
    name: notEmpty,
});
export const validate_users = validate_by_specification({
    name: notEmpty,
    key_and_radiotag_list: validate_link_list(idExtractor([TMKey])),
    role_list: validate_link_list(createSelector(UserRole.get.all, objects2ids)),
    password: onlyDigits,
});
export const validate_radiomodules = validate_by_specification({
    name: notEmpty,
    connection_timeout: notNullAnd(minMax(10, 30)),
});
export const validate_radiosensors433 = validate_by_specification({
    name: notEmpty,
    trigger_reset_time: notNullAnd(minMax(0, 30)),
    rol_triggered: validate_link_list(default_reactions),
});
export const validate_fobs = validate_by_specification({
    name: notEmpty,
});
export const validate_fob_buttons = validate_by_specification({
    name: notEmpty,
    commands: validate_link_list(default_reactions),
});
export const validate_tm_keys = validate_by_specification({
    name: notEmpty,
    touch_actions: validate_link_list(idExtractor([Command, OutputAction])),
});
export const validate_user_roles = validate_by_specification({
    name: notEmpty,
    managed_guard_zone_list: validate_link_list(idExtractor([GuardZone])),
    user_list: validate_link_list(idExtractor([User])),
});
export const validate_gsm_settings = validate_by_specification({
    ussd: (value) => value.match(/^[0-9#*+-]*$/)
        ? null
        : 'Должно содержать только цифры, +/-/#/*',
    threshold: notNullAnd(minMax(0, 100000)),
    notification: orNull(validate_link(true, idExtractor([Notification]))),
});
const getBoilersId = (config) => objects2ids(HeatingCircuit.get.where(config, HeatingCircuit.isBoiler));
export const validate_boiler_groups = all_merge(validate_by_specification({
    name: notEmpty,
    rotation_period: notNullAnd(minMax(1, 30)),
    slave_boiler_switch_delay: notNullAnd(minMax(1, 300)),
    boiler_list: all((list) => {
        if (list.length < 2) {
            return 'Необходимо выбрать несколько контуров котла';
        }
        return null;
    }, validate_link_list(getBoilersId)),
}), (boiler_group) => {
    return check_null_values({
        lead_boiler_id: boiler_group.setting_register !== 1
            ? null
            : boiler_group.lead_boiler_id == null
                ? 'Должен быть выбран'
                : boiler_group.boiler_list == null
                    ? null
                    : noBrokenLinks([boiler_group.lead_boiler_id], boiler_group.boiler_list),
    });
});
export const validate_radiosensors = all_merge(validate_by_specification({
    // Т.к. в старых приборах ещё есть пустые строки
    // upper_threshold: (value) =>
    //     //@ts-ignore
    //     value === '' ? null : orNull(minMax(-50, 120))(value),
    // lower_threshold: (value) =>
    //     //@ts-ignore
    //     value === '' ? null : orNull(minMax(-50, 120))(value),
    hysteresis: notNullAnd(minMax(0, 100)),
    upper_humidity_threshold: notNullAnd(minMax(0, 100)),
    lower_humidity_threshold: notNullAnd(minMax(0, 100)),
    humidity_hysteresis: notNullAnd(minMax(0, 100)),
    setting_register: (value, global) => {
        if ((value & RadioSensor.Flags.IS_OUTSIDE) > 0 &&
            streetSensorCount(global) > 1) {
            return 'Уличный датчик уже выбран';
        }
        if ((value & RadioSensor.Flags.IS_OUTSIDE_RESERVE) > 0 &&
            reserveStreetSensorCount(global) > 1) {
            return 'Резервный уличный датчик уже выбран';
        }
        return null;
    },
    no_connection_timeout: notNullAnd(minMax(10, 60)),
    movement_leakage_trigger_reset_time: notNullAnd(minMax(0, 30)),
    calibration_shift: orNull(minMax(-10, 10)),
}), (sensor, config) => {
    const is_climatic = isClimatic(config.device.name);
    return check_null_values({
        name: is_climatic
            ? notEmptyAnd(maxStringLength(10, 'должно быть не более 10 знаков'))(sensor.name)
            : notEmpty(sensor.name),
        upper_threshold: validateThresholdRadio(sensor, sensor.upper_threshold),
        lower_threshold: validateThresholdRadio(sensor, sensor.lower_threshold),
    });
});
export const validate_analog_temperature_sensors = all_merge(validate_by_specification({
    name: notEmpty,
    type: (value) => (value === -1 ? 'Тип должен быть выбран' : null),
    // @ts-ignore
    physical_input_num: all(partial(inputDontClashesWithOutputs, 'analog_temperature_sensors'), inputNumberIsValid, inputNumberIsBusy),
    hysteresis: notNullAnd(minMax(0, 100)),
    setting_register: (value, global) => {
        if ((value & AnalogTemperatureSensor.Flags.IS_OUTSIDE) > 0 &&
            streetSensorCount(global) > 1) {
            return 'Уличный датчик уже выбран';
        }
        if ((value & AnalogTemperatureSensor.Flags.IS_OUTSIDE_RESERVE) > 0 &&
            reserveStreetSensorCount(global) > 1) {
            return 'Резервный уличный датчик уже выбран';
        }
        return null;
    },
    no_connection_timeout: notNullAnd(minMax(0, 10)),
    pull_up: notNullAnd(minMax(0, 500)),
    calibration_shift: notNullAnd(minMax(-10, 10)),
    rol_connection_lost: validate_link_list(default_reactions),
    rol_temperature_upper_threshold: validate_link_list(default_reactions),
    rol_temperature_lower_threshold: validate_link_list(default_reactions),
    recovery_list: validate_link_list(default_reactions),
}), (sensor) => {
    return check_null_values({
        ntc: sensor.type === -1
            ? sensor.ntc == null
                ? null
                : 'NTC должно отсутствовать'
            : null,
        upper_threshold: validateThresholdAnalog(sensor, sensor.upper_threshold),
        lower_threshold: validateThresholdAnalog(sensor, sensor.lower_threshold),
    });
});
const notEmptyMinMaxWithShift = (min, max, realMin, realMax) => (value) => {
    return notNullAnd(minMax(realMin, realMax))(value)
        ? 'Значение вышло за допустимые пределы [' + min + ', ' + max + ']'
        : null;
};
const getAllDutsEgtsIds = createSelector(AnalogDut.get.all, DigitalDut.get.all, (ads, dds) => removeNulls([...ads.map((d) => d.egts), ...dds.map((d) => d.egts)]));
const notUniqueEgts = (value, global) => {
    const error = notEmptyMinMaxWithShift(1, 8, 0, 7)(value);
    if (error)
        return error;
    const ids = getAllDutsEgtsIds(global).filter((e) => e != null);
    return ids.length > new Set(ids).size ? 'Адреса не должны повторяться' : null;
};
export const validate_digital_duts = validate_by_specification({
    serial: all(minMaxStr(0, 10), onlyDigits),
    name: all(notEmpty, minMaxStr(1, 60)),
    no_connection_timeout: notNullAnd(minMax(1, 5)),
    egts: notUniqueEgts,
});
export const validate_analog_duts = validate_by_specification({
    name: all(notEmpty, minMaxStr(1, 60)),
    lower_threshold: notNullAnd(minMax(0, 5)),
    no_connection_timeout: notNullAnd(minMax(1, 5)),
    egts: notUniqueEgts,
});
const validate_duplicate = (array, query) => {
    let count = 0;
    for (let i = 0; i < array.length; ++i) {
        if (array[i] === query && query !== 0)
            count++;
    }
    return count > 1 ? 'На разные функции назначен один и тот же датчик' : null;
};
export const validate_heating_circuits = all_merge(validate_by_specification({
    name: notEmpty,
    external_thermostat: validate_link(true, idExtractor([AnalogInput])),
}), (hc, config) => {
    const device_spec = getDeviceSpec(config?.device?.name, config?.device?.hardware);
    if (device_spec.heating.has_heating &&
        device_spec.heating.max_boiler_circuits_count != null) {
        if (
        // Exemption for this serial is made based on email from Denis Ivanov dated 2021-08-03:
        config?.login?.toUpperCase() !== '68497B1F9D6A' &&
            // добавлены h1500 pro после истерики в чате монтажников 2024.02.15
            config?.login?.toUpperCase() !== '1C4D9CC221EB' &&
            config?.login?.toUpperCase() !== 'E4096DFD1F2F') {
            const max_boiler_count = device_spec.heating.max_boiler_circuits_count;
            if (HeatingCircuit.get.where(config, HeatingCircuit.isBoiler)
                .length > max_boiler_count) {
                return `Нельзя настроить более ${max_boiler_count} ${plural(max_boiler_count, 'котла', 'котлов', 'котлов')}`;
            }
        }
    }
    let array = [
        hc.air_temp_sensor,
        hc.air_temp_sensor_reserve,
        hc.dhw_temp_sensor,
        hc.dhw_temp_sensor_reserve,
        hc.water_temp_sensor,
        hc.water_temp_sensor_reserve,
    ];
    const street_sensor_count = streetSensorCount(config);
    const boiler_adapters_ids = objects2ids(BoilerAdapter.get.all(config));
    array = array.filter((item) => item != null
        ? !boiler_adapters_ids.includes(item)
        : false);
    const only_temp_sensors = get_temperature_sensors(config);
    const temps_sensors_with_adapters = get_temperature_sensors_plus_adapters_ids(config);
    const tooManyBoilerAdapters = BoilerAdapter.get.where(config, ({ id }) => hc.control_devices.includes(id)).length > 1
        ? 'Максимум один адаптер котла разрешён для выбора'
        : null;
    const noBoilerAdapters = (value) => {
        return HeatingCircuit.isBoiler(hc) || HeatingCircuit.isDHW(hc)
            ? null
            : BoilerAdapter.get.some(config, ({ id }) => id === value)
                ? 'Для данного теплового контура не допускается выбор адаптера котла'
                : null;
    };
    const noThreewayTaps = (value) => {
        return HeatingCircuit.isCooling(hc) || HeatingCircuit.isConsumer(hc)
            ? null
            : ThreewayTap.get.some(config, ({ id }) => id === value)
                ? 'Для данного теплового контура не допускается выбор трёхходового крана'
                : null;
    };
    const ids = idExtractor([HeatingCircuit, BoilerGroup, BoilerCascade])(config);
    const showATS = (HeatingCircuit.isAirConsumerMode(hc) ||
        HeatingCircuit.isAirPIDConsumerMode(hc)) &&
        HeatingCircuit.isConsumer(hc);
    const is_dhw = HeatingCircuit.isDHW(hc);
    const is_baxi = branding.code == 'baxi';
    const is_climatic = isClimatic(config.device.name);
    return check_null_values({
        hysteresis: is_climatic
            ? notNullAnd(minMax(0, 10))(hc.hysteresis)
            : notNullAnd(minMax(0, 100))(hc.hysteresis),
        water_min_temperature: is_dhw
            ? null
            : is_baxi
                ? notNullAnd(minMax(0, 40))(hc.water_min_temperature)
                : is_climatic
                    ? notNullAnd(minMax(5, 85))(hc.water_min_temperature)
                    : notNullAnd(minMax(-30, 130))(hc.water_min_temperature),
        water_max_temperature: is_dhw
            ? null
            : is_climatic
                ? notNullAnd(minMax(5, 85))(hc.water_max_temperature)
                : notNullAnd(minMax(-30, 130))(hc.water_max_temperature),
        air_temp_sensor: !showATS
            ? null
            : hc.air_temp_sensor == null
                ? null
                : validate_duplicate(array, hc.air_temp_sensor) ||
                    noBrokenLinks([hc.air_temp_sensor], only_temp_sensors),
        air_temp_sensor_reserve: !showATS
            ? null
            : hc.air_temp_sensor_reserve == null
                ? null
                : validate_duplicate(array, hc.air_temp_sensor_reserve) ||
                    noBrokenLinks([hc.air_temp_sensor_reserve], only_temp_sensors),
        dhw_temp_sensor: !is_dhw
            ? null
            : hc.dhw_temp_sensor == null
                ? /*"Должен быть выбран"*/ null
                : validate_duplicate(array, hc.dhw_temp_sensor) ||
                    noBrokenLinks([hc.dhw_temp_sensor], temps_sensors_with_adapters),
        dhw_temp_sensor_reserve: !is_dhw
            ? null
            : hc.dhw_temp_sensor_reserve == null
                ? null
                : validate_duplicate(array, hc.dhw_temp_sensor_reserve) ||
                    noBrokenLinks([hc.dhw_temp_sensor_reserve], temps_sensors_with_adapters),
        water_temp_sensor: hc.water_temp_sensor == null
            ? HeatingCircuit.isConsumer(hc) &&
                (HeatingCircuit.isAirPIDConsumerMode(hc) ||
                    HeatingCircuit.isWaterConsumerMode(hc))
                ? /*"Должен быть выбран"*/ null
                : null
            : validate_duplicate(array, hc.water_temp_sensor) ||
                noBrokenLinks([hc.water_temp_sensor], temps_sensors_with_adapters),
        water_temp_sensor_reserve: hc.water_temp_sensor_reserve == null
            ? null
            : validate_duplicate(array, hc.water_temp_sensor_reserve) ||
                noBrokenLinks([hc.water_temp_sensor_reserve], temps_sensors_with_adapters),
        control_devices: validate_array(noBoilerAdapters)(hc.control_devices) ||
            tooManyBoilerAdapters ||
            validate_array(noThreewayTaps)(hc.control_devices) ||
            noBrokenLinks(hc.control_devices, [
                ...([
                    HeatingCircuit.Type.BOILER,
                    HeatingCircuit.Type.DHW,
                ].includes(hc.type)
                    ? BoilerAdapter.get.all(config)
                    : []),
                ...RelayControl.get.all(config),
                ...Pump.get.all(config), // filter: () => [2,3].includes(heating_circuit.type)},
                ...([
                    HeatingCircuit.Type.COOLING,
                    HeatingCircuit.Type.HEATING,
                ].includes(hc.type)
                    ? ThreewayTap.get.all(config)
                    : []),
                ...AnalogOutput.get.all(config),
            ].map(object2id)),
        heat_request: ![1, 3].includes(hc.type)
            ? hc.heat_request === 0
                ? null
                : "Должно быть 'Не используется'"
            : [
                0,
                0xff00,
                0xffff,
                2730,
                2780,
                2830,
                2830 + 50,
                2930,
                2930 + 50,
                3030,
                3030 + 50,
                3130,
                3130 + 50,
                300,
                350,
                400,
                450,
                500,
                550,
                600,
                650,
                700,
                750,
                800,
                850,
                900,
                950,
            ].includes(hc.heat_request)
                ? null
                : 'Не допустимое значение',
        heat_source: ![1, 3].includes(hc.type)
            ? hc.heat_source == null
                ? null
                : 'Должно отсутствовать'
            : hc.heat_source == null
                ? null
                : noBrokenLinks([hc.heat_source], ids),
        summer_threshold: hc.type > 1 && hc.winter_summer_switch
            ? notNullAnd(minMax(5, 40))(hc.summer_threshold)
            : null,
        pza: is_climatic &&
            HeatingCircuit.getControlModeClimatic(hc) ===
                HeatingCircuit.ControlMode.PZA
            ? minMax(0.2, 4)(Number(hc.pza))
            : hc.pza != null && hc.pza <= 10
                ? hc.pza <= 0
                    ? null
                    : isClimatic(config?.device?.name)
                        ? notNullAnd(minMax(0, 10))(hc.pza)
                        : null
                : street_sensor_count === 0
                    ? null // Предупреждение о необходимости добавить интернет-погоду в UI
                    : street_sensor_count === 1
                        ? null
                        : 'Ровно один датчик из адаптеров котла и датчиков температуры должен быть уличным',
        delta_temp: hc.delta_temp
            ? minMax(1, 250, `Допустимые значения: от ${0.1} до ${25}`)(hc.delta_temp)
            : null,
        turn_off_delay: is_climatic
            ? minMax(0, 120)(hc.turn_off_delay)
            : notNullAnd(minMax(0, 600))(hc.turn_off_delay),
    });
});
export const validate_firmware = (item) => {
    const last_firmwares = window._ui.store.getState()?.last_firmwares;
    if (!last_firmwares) {
        return null;
    }
    const firmware = last_firmwares[item.hardware]?.[item.name];
    if (!firmware) {
        return null;
    }
    if (parseInt(item.firmware, 10) < firmware.version[0]) {
        return `Есть обновление прошивки устройства (${item.firmware} < ${firmware.version[0]})`;
    }
    return null;
};
export const validate_warnings_config = all_merge(validate_by_specification({
    analog_inputs: orNull(validate_array(validate_warnings_analog_inputs)),
    wired_temperature_sensors: orNull(validate_array(validate_warnings_wired_temperature_sensors)),
    analog_temperature_sensors: orNull(validate_array(validate_warnings_analog_temperature_sensors)),
    notifications: orNull(validate_array(validate_warnings_notification)),
    scenarios: orNull(validate_array(validateWarningsScenarios)),
    output_actions: orNull(validate_array(validate_physical_output)),
    buzzers: orNull(validate_array(validate_physical_output)),
    guard_indicators: orNull(validate_array(validate_physical_output)),
    pumps: orNull(validate_array(validate_physical_output)),
    relay_controls: orNull(validate_array(validate_physical_output)),
    threeway_taps: orNull(validate_array(validate_warnings_threeway_taps)),
    heating_circuits: orNull(validate_array(validate_warnings_heating_circuits)),
    heating_modes: orNull(validate_array(validate_warnings_heating_modes)),
    io_extensions: orNull(validate_array(validate_warnings_io_extensions)),
    web_elements: orNull(validate_array(validate_warnings_web_elements)),
    users: orNull(validate_array(validate_warnings_users)),
    modbus_signals: orNull(validate_array(validate_warnings_modbus_signal)),
    mqtt_topics: orNull(validate_array(validate_mqtt_topic)),
    analog_outputs: orNull(validate_array(validate_warnings_analog_outputs)),
    device: validate_firmware,
}), (config) => {
    // https://git.microline.ru/zont/server/-/issues/1655
    if (['SMART', 'SMART20_PRO', 'H1V', 'H1V02_PRO'].includes(config.device.name)) {
        if (AnalogTemperatureSensor.get.all(config).length == 0) {
            const other_sensors_length = WiredTemperatureSensor.get.all(config).length +
                getRadioThermometers(config).length;
            if (other_sensors_length >= 3) {
                return null;
            }
            return check_null_values({
                analog_temperature_sensors: 'Для корректной работы устройства — добавьте датчик NTC',
            });
        }
        return null;
    }
    return null;
});
export const validate_wifi_password = (value) => {
    if (value == '') {
        return null;
    }
    return value.match(/^[\u0020-\u007e]{8,63}$/)
        ? null
        : 'Должно содержать только цифры, буквы или спецсимволы (printable ASCII characters). От 8 до 63 знаков.';
};
export const validate_wifi_name = (value) => {
    if (value == '') {
        return null;
    }
    return value.match(/^[^!#;+\]/"\t][^+\]/"\t]{0,31}$/)
        ? null
        : 'Должно содержать только цифры, буквы или спецсимволы. До 32 знаков.';
};
export const validate_wifi_access_point_ssid = (value) => {
    if (value == '') {
        return null;
    }
    return value.match(/^[^!#;+\]/"\t][^+\]/"\t]{0,23}$/)
        ? null
        : 'Должно содержать только цифры, буквы или спецсимволы. До 24 знаков.';
};
export const validate_wifi_access_point_password = (value) => {
    if (value == '') {
        return null;
    }
    return value.match(/^[\u0020-\u007e]{8,23}$/)
        ? null
        : 'Должно содержать только цифры, буквы или спецсимволы (printable ASCII characters). От 8 до 24 знаков.';
};
export const validate_wifi_settings = validate_by_specification({
    netname: validate_wifi_name,
    pass: validate_wifi_password,
});
export const wifi_access_point = validate_by_specification({
    ssid: validate_wifi_access_point_ssid,
    password: validate_wifi_access_point_password,
});
const threeway_mgs = 'Выход используется для разных устройств';
export const validate_config = all_merge(validate_by_specification({
    port: notNullAnd(minMax(1, 65535)),
    gsm_settings: orNull(validate_gsm_settings),
    wifi_settings: orNull(validate_wifi_settings),
    wifi_access_point: orNull(wifi_access_point),
    analog_inputs: orNull(validate_array(validate_analog_inputs)),
    wired_temperature_sensors: orNull(validate_array(validate_wired_temperature_sensors)),
    analog_temperature_sensors: orNull(validate_array(validate_analog_temperature_sensors)),
    guard_zones: orNull(validate_array(validate_guard_zone)),
    notifications: orNull(validate_array(validate_notification)),
    scenarios: orNull(validate_array(validateScenario)),
    users: orNull(validate_array(validate_users)),
    output_actions: orNull(validate_array(validate_output_actions)),
    boiler_adapters: orNull(validate_array(validate_boiler_adapters)),
    radiomodules: orNull(validate_array(validate_radiomodules)),
    radiosensors: orNull(validate_array(validate_radiosensors)),
    radiosensors433: orNull(validate_array(validate_radiosensors433)),
    fobs: orNull(validate_array(validate_fobs)),
    fob_buttons: orNull(validate_array(validate_fob_buttons)),
    buzzers: orNull(validate_array(validate_buzzers)),
    guard_indicators: orNull(validate_array(validate_guard_indicators)),
    pumps: orNull(validate_array(validate_pumps)),
    relay_controls: orNull(validate_array(validate_relay_controls)),
    threeway_taps: orNull(validate_array(validate_threeway_taps)),
    heating_circuits: orNull(validate_array(validate_heating_circuits)),
    boiler_groups: orNull(validate_array(validate_boiler_groups)),
    tm_keys: orNull(validate_array(validate_tm_keys)),
    user_roles: orNull(validate_array(validate_user_roles)),
    heating_modes: orNull(validate_array(validate_heating_modes)),
    io_extensions: orNull(validate_array(validate_io_extensions)),
    web_elements: orNull(validate_array(validate_web_elements)),
    digital_duts: orNull(validate_array(validate_digital_duts)),
    analog_duts: orNull(validate_array(validate_analog_duts)),
    boiler_cascades: orNull(validate_array(validate_boiler_cascades)),
    modbus_signals: orNull(validate_array(validate_modbus_signal)),
    modbus_devices: orNull(validate_array(validate_modbus_device)),
    analog_outputs: orNull(validate_array(validate_analog_outputs)),
}), (config) => {
    const phys_outputs_counter = new Map();
    getManagedMechanismOutputs(config).forEach(({ num: p_o }) => {
        if (phys_outputs_counter.has(p_o)) {
            phys_outputs_counter.set(p_o, phys_outputs_counter.get(p_o) + 1);
        }
        else {
            phys_outputs_counter.set(p_o, 0);
        }
    });
    //Прошлись по все трёх-ходовым кранам
    const threeway_tap_result = removeNulls(ThreewayTap.get.all(config).map(({ physical_output1, physical_output2 }) => {
        const po1 = phys_outputs_counter.get(physical_output1) > 1;
        const po2 = phys_outputs_counter.get(physical_output2) > 1;
        if (po1 && po2) {
            return {
                physical_output1: threeway_mgs,
                physical_output2: threeway_mgs,
            };
        }
        if (po1) {
            return {
                physical_output1: threeway_mgs,
            };
        }
        if (po2) {
            return {
                physical_output2: threeway_mgs,
            };
        }
        return null;
    }));
    const simple_fields = [
        'buzzers',
        'guard_indicators',
        'pumps',
        'relay_controls',
    ];
    const simple_field_result = Object.fromEntries(simple_fields.map((field_name) => {
        const result = (config[field_name] ?? []).map((obj) => {
            return phys_outputs_counter.get(obj.physical_output) > 0
                ? {
                    physical_output: 'Выход используется для разных устройств',
                }
                : null;
        });
        return [field_name, removeNulls(result).length ? result : null];
    }));
    return check_null_values({
        threeway_taps: threeway_tap_result.length > 0 ? threeway_tap_result : null,
        ...simple_field_result,
    });
});
